import { COMMON_API_URL } from "./urls.ts";

// Browser requests carry a Wing login token. The PHP proxy validates it and
// supplies the insurer gateway's server credential for lifecycle, calculator,
// and provider requests. Keep the override for explicitly configured gateways.

export const CALCULATOR_BASE_URL =
  // @ts-ignore
  import.meta.env.VITE_CALCULATOR_API_URL ?? `${COMMON_API_URL}/insurers`;
